<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="d-flex justify-content-between">
        <div class="section-title">
           Refund Analysis Report
        </div>
        <div class="d-flex align-items-center">
          
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-4 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                    ✖
                  </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                    @selected="onChangeDate($event, 'from')"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                    ✖
                  </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>

            <!-- Screen filter -->
                <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
                         <div class="dropdown-curve-container">
                           <label
                             :class="
                                selectedScreen && selectedScreen.length > 0
                                 ? 'shift-up'
                                 : 'font-weight-bold'
                             "
                             >{{ $t("select") }} {{ $t("screens") }}</label
                           >
                           <multiselect
                             :options="screenList"
                             v-model="selectedScreen"
                             placeholder=""
                             label="screen_name"
                             :multiple="true"
                             :close-on-select="false"
                             track-by="screen_id"
                           ></multiselect>
                         </div>
                       </div>
            <!-- Screen filter -->

                    <!-- User Filter -->
                                 <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                                           <div class="dropdown-curve-container">
                                            <label
                                       :class="
                                          selectedUsers && selectedUsers.length > 0
                                           ? 'shift-up'
                                           : 'font-weight-bold'
                                       "
                                       > {{ selectedUsers && selectedUsers.length > 0 ? $t("User") : $t("All Users") }}</label
                                     >
                                             <multiselect
                                               :options="Users"
                                               v-model="selectedUsers"
                                               placeholder=""
                                               label="username"
                                               :multiple="true"
                                               :close-on-select="true"
                                               track-by="user_id"
                                             ></multiselect>
                                           </div>
                                         </div>
                            <!-- User Filter -->

                               <!-- Distributor Filter -->
                                        <div class="col-lg-6 col-xl-3 mb-4">
                                                 <div class="d-flex align-items-center">
                                                   <div class="dropdown-curve-container">
                                                     <label :class="selectedDistributor.length > 0 ? 'shift-up' : 'font-weight-bold'">
                                                      {{ selectedDistributor && selectedDistributor.length > 0 ? $t("Distributors") : $t("All Distributors") }}
                                                     </label>
                                     
                                                     <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                                                       @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                                                       :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                                                       name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
                                                     </multiselect>
                                                   </div>
                                                 </div>
                                               </div>
                                    <!-- Distributor Filter -->

                                    <!-- Movie Filter -->
                                      <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                                               <div class="dropdown-curve-container">
                                                 <label :class="selectedMovieName && selectedMovieName.length > 0 ? 'shift-up' : 'font-weight-bold'">
                                                   {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}
                                                 </label>
                                                 <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
                                                   label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
                                                 </multiselect>
                                               </div>
                                             </div>
                                    <!-- Movie Filter -->

               <!-- show time filter -->
                               <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                 <vue-timepicker manual-input
                                  v-model="start_time"
                                   id="starttime"
                                   name="starttime"
                                   :placeholder="$tc('starttime')"
                                   format="HH:mm" 
                                   class="time_picker" 
                                   input-width="100%" auto-scroll
                                   lazy ></vue-timepicker>
                               </div>
                  
             
                       <div class="position-relative col-lg-3 col-xl-2 mb-2">
               <vue-timepicker
                 manual-input
                 v-model="end_time"
                 id="endtime"
                 name="endtime"
                 :placeholder="$tc('endtime')"
                 format="HH:mm"
                 class="time_picker"
                 input-width="100%"
                 auto-scroll
                 lazy
               />
             </div>
            <!-- show time filter -->

                <!-- Payment Filter -->
                          <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
                                   <div class="dropdown-curve-container">
                                      <label
                                                     :class="
                                                       selectedPaymentSource && selectedPaymentSource.length > 0
                                                         ? 'shift-up'
                                                         : 'font-weight-bold'
                                                     "
                                                     > {{ selectedPaymentSource && selectedPaymentSource.length > 0 ? $t("Payment Mode") : $t("All Payment Mode") }}</label
                                                   >
                                     <multiselect
                                       :options="paymentList"
                                       v-model="selectedPaymentSource"
                                       placeholder=""
                                       label="pm_payment_mode"
                                       :multiple="true"
                                       :close-on-select="false"
                                       track-by="pm_id"
                                       :showLabels="false"
                                     ></multiselect>
                                   </div>
                                 </div>
                      <!-- Payment Filter -->
  
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="getRefundsData('N','N')"
              >
                {{ $t("fetch") }}
                {{ $t("report") }}
              </button>
            </div>
  
            <div
              v-if="refundRecords.length > 0"
              class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
              <!-- s -->
  
              <a
                target="_blank"
                @click="getRefundsData('Y','N')"
                title="Download as Pdf"
                download
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf.svg"
                  height="25"
                  width="25"
                  style="cursor: pointer"
                />
              </a>
              <a
                target="_blank"
                @click="getRefundsData('N','Y' )"
                title="Download as Excel"
                download
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                  style="cursor: pointer"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          style="overflow-x: scroll; width: auto !important"
          v-if="refundRecords.length > 0"
          ref="exportable_table"
        >
          <table class="swc-report-table"
          :class="lang_id == 2 ? 'swc-report-table reverse-order' : 'swc-report-table order'"
          border="1">
            <thead class="bg-lightgrey font-weight-bold">
              <th colspan="2">{{ trans("transactionnumber",lang_id) }}</th>
              <th>{{ trans("bookingdate",lang_id) }}</th>
              <th>{{ trans("filmname",lang_id) }}</th>
              <th>{{ trans("showDateTime",lang_id) }}</th>
              <!-- <th>{{ trans("showTime",lang_id) }}</th> -->
              <th>{{ trans("screenname",lang_id) }}</th>
              <th>{{ trans("salesChannel",lang_id) }}</th>
              <th>{{ trans("seatnumber",lang_id) }}</th>

              <th>{{ trans("serialNo",lang_id) }}</th>
              <th>{{ trans("noOfTickets",lang_id) }}</th>
              <th>{{ trans("ticketPrice",lang_id) }}</th>


              <th>{{ trans("refundamount",lang_id) }}</th>
              <th>{{ trans("refunddatetime",lang_id) }}</th>
              <th>{{ trans("minutesaftersessionstarted",lang_id) }}</th>
              <th>{{ trans("refundreason",lang_id) }}</th>
              <th>{{ trans("refundedby",lang_id) }}</th>
              <th>{{ trans("authorizedby",lang_id) }}</th>
              <th>{{ trans("paymentmode",lang_id) }}</th>
              <th>{{ trans("customername",lang_id) }}</th>
              <th>{{ trans("mobileno",lang_id) }}</th>
              <th>{{ trans("boremarks",lang_id) }}</th>
            </thead>
            <tbody
              v-if="refundRecords.length > 0"
              class="sph-report"
              :style="cssVars"
            >
              <tr
                v-for="(transaction, transactionIndex) in refundRecords"
                :key="transactionIndex"
              >
                <td colspan="2" :class="transaction.isSwap > 0 ? 'swap text-left' : 'text-left'">
                  {{ transaction.sb_booking_code }}
                </td>
                <td>{{ transaction.t_booking_date_time | fulldateparse }}</td>
                <td :class="lang_id==1?'text-left':'text-right'">{{ lang_id == 1? transaction.film_name:transaction.movie_title_3?transaction.movie_title_2:transaction.film_name}}</td>
                <td>{{ transaction.t_show_date + ' ' + transaction.t_show_time }}</td>
                <!-- <td class="text-right">{{ transaction.t_show_time }}</td> -->
                <td :class="lang_id==1?'text-left':'text-right'">{{ lang_id == 1? transaction.screen_name:transaction.alternate_screen_name_language?transaction.alternate_screen_name_language:transaction.screen_name }}</td>
                <td class="text-left">{{ transaction.booking_source }}</td>
                <td class="text-break text-left">{{ transaction.seats }}</td>

                <td class="text-break text-right">{{ transaction.serial_no }}</td>
                <td class="text-break text-right">{{ transaction.total_ticket }}</td>
                <td class="text-break text-right">{{ transaction.ticket_price }}</td>


                <td class="text-right">
                  {{ transaction.total_refund_amount | RoundOff }}
                </td>
                <td class="text-left">
                  {{ transaction.t_refund_date_time || "" }}
                </td>
                <td class="text-right">
                  {{
                   transaction.time_difference || '-'
                  }}
                </td>
                <td class="text-left">{{ transaction.rr_reason || "-" }}</td>
                <td class="text-left">{{ transaction.refunded_by || "-" }}</td>
                <td class="text-left">
                  {{ transaction.refund_approved_by || "-" }}
                </td>
                <td class="text-left">
                  {{ transaction.pm_payment_mode || "-" }}
                </td>
                <td class="text-left">
                  {{ transaction.customer_name || transaction.guest_name || "-" }}
                </td>
                <td class="text-right">
                  {{
                    transaction.cust_mobile || transaction.guest_mobile || "-"
                  }}
                </td>
                <td class="text-left">
                  {{ transaction.bo_trx_remarks || "-" }}
                </td>
              </tr>
              <tr class="bg-lightgrey font-weight-bold">
                <td colspan="9" class="text-left">{{ trans("total",lang_id) }}</td>
                <td class="text-right">{{grandTotal.no_of_ticket_total}}</td>
                <td class="text-right">{{grandTotal.ticket_price_total}}</td>
                <td class="text-right">{{grandTotal.refund_amount_total}}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="14">
                  <!-- <p class="h6 text-center">{{ $tc("NoRecords") }}</p> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState, mapActions, mapGetters } from "vuex";

  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
         VueTimepicker
    },
    data() {
      return {
           selectedMovieName: [],
              allMovieNames: [],
         selectedDistributor:[],
        BASEURL,
  selectedUsers:[],
        Users:[],
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: null,
        toDate: null,
        refundRecords: [],
        excelFilePath: "",
        grandTotal: {},
        lang_id:"1",
        selectedScreen: [],
        screenList: [],
        end_time: "",
        start_time: "",
        paymentList:[],
        selectedPaymentSource:[],
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
       this.getPaymentTypes();
        this.fetchReportDistributorsList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
      this.getUsers();
    },
    computed: {
      cssVars() {
        return {
          "--swap-color": this.swaptextcolor,
        };
      },
      distributorIds() {
          let text = ``;
          if (this.selectedDistributor.length > 0) {
            text = this.selectedDistributor.map(x => x.d_id).join(",");
          }
    
          return text;
        },
         ...mapGetters([
          "getDistributorReportDropdownList"
          //   "getDistributorReportMoviesList",
        ]),
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
       fromDate() {
          this.getRefundsData("N", "N", "filter");
        },
        toDate() {
          this.getRefundsData("N", "N", "filter");
        },
    },
    mounted() {},
    methods: {
      onSelectHandler(event,type){
        if (type =="distributor") {
        this.d_id = event.d_id;
        // this.selectedMovie = [];
        // this.MovieList = [];
         this.fetchDistributorMovies();
        // this.selectedDistributor = event;
      }
      },
       onRemoveHandler(event,type){
              
          },
            fetchDistributorMovies() {
                if (!this.dropDown.selectedCinemaId) {
                  this.$toasted.show("Please Select Cinema");
                  this.selectedDistributor = [];
                  this.$forceUpdate();
                } else {
                  this.MovieList = [];
                  let payload = {
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    cinema_id: this.dropDown.selectedCinemaId,
                      cinema_name: this.dropDown.selectedCinemaName,
                      cinema_address: this.dropDown.selectedCinemaAddres,
                    d_id: this.distributorIds,
                    d_company_name: this.selectedDistributor
                      .map(x => x.d_company_name)
                      .join(","),
                    country_id: authenticationService.get("BRGLOPCO"),
                    filter_with_key: "ss_actual_start_date"
                  };
                  ReportService.GetDistributorMovieFormat(payload)
                    .then(response => {
                      const { data } = response;
                      if (data && data.status && data.Records) {
                        this.MovieList = data.Records;
                      } else
                        this.$toasted.show(data.message || "Opps! Something went wrong");
                    })
                    .catch(error => {
                      this.$toasted.show(
                        "Catch Error on ReportStore fetchDistributorMovies",
                        error
                      );
                    });
                }
              },
                ...mapActions([
                    // FETCH FROM MASTER STORE
                    "fetchCinemasList",
                    // "fetchDistributorsList",
                    // "fetchDistributorsActiveMasterMovie",
                    // FETCH LIST ONLY
                    "fetchReportDistributorsList",
                    "fetchDistributorReportList",
                    "onDistributorReportDateHandler",
                    "onDistributorReportDropdownHandler",
                    "onDistributorReportFlagHandler",
                    "onResetDistributorStoreState"
                  ]),
          getPaymentTypes() {
            let body = {
              tableName: "ms_payment_modes",
              pm_is_active: "Y"
            };
            MasterService.GetActiveList(body).then(response => {
              const { data } = response;
              if (data && data.status) {
                if (data.Records.length > 0) {
                  this.paymentList = data.Records;
                 
                }
              } else this.$toasted.show(data.message || "Opps! Something went wrong");
            });
          },
      onChangeDate: function (e, type){
          if(type == 'from'){
              this.toDate = new Date(e);
              this.$forceUpdate();
          }
      },
      moment,
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: `RawMaterialSupplierWise`,
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn ||
                `RawMaterialSupplierWiseCost-${
                  this.dropDown.selectedCinemaName
                }.${type || "xlsx"}`
            );
      },
      getCinemaList: function () {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
        this.getCinemaScreens()
      },
        async getUsers(index) {
                    try {
                      const response = await MasterService.GetActiveList({
                        tableName: "users",
                        is_active: "Y",
                      });
                      const { data } = response;
                      if (data.status && data.Records.length > 0) {
                        this.Users = data.Records.filter(user=>user.role_id==4);
                       // console.log("Users",this.Users)
                      } else {
                        console.log("show error:", data.message);
                      }
                    } catch (error) {
                      this._CatchError(error);
                    }
                  },
        async getCinemaScreens(index) {
            try {
              const response = await MasterService.GetActiveList({
                tableName: "screens",
                screen_is_active: "Y",
                cinema_id: this.dropDown.selectedCinemaId,
              });
              const { data } = response;
              if (data.status && data.Records.length > 0) {
                this.screenList = data.Records;
              } else {
                console.log("show error:", data.message);
              }
            } catch (error) {
              this._CatchError(error);
            }
          },
      getRefundsData(isPdf = "N", isExcel = "N",type = "") {
        if (isExcel == "N") {
          this.refundRecords = [];
        }
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          screen_id: this.selectedScreen.map(x => x.screen_id),
          screen_name: this.selectedScreen.map(x => x.screen_name),
          start_time:this.start_time,
          end_time:this.end_time,
          payment_mode_id: this.selectedPaymentSource.map(x => x.pm_id),
          payment_mode_name: this.selectedPaymentSource.map(x => x.pm_payment_mode),
          user_id : this.selectedUsers.map(x => x.user_id),
          username : this.selectedUsers.map(x => x.username),
             d_id: this.distributorIds,
              d_company_name: this.selectedDistributor.map(x => x.d_company_name).join(","),
          isExcel,
          isPdf,
          lang_id:this.lang_id
        };
          if (type === "filter") {
            payload["type"] = "filter";
          }
        
            if (this.selectedMovieName.length) {
              payload["selectedMovieName"] = this.selectedMovieName.map(
                (item) => {
                  return item.movie_name;
                }
              );
            }
        //console.log("payload",payload)
        ReportsService.GetTransactionRefundsOld(payload)
          .then((response) => {
            const { data } = response;
             if (!data.status) return this.$toasted.show(data.message);
                 if (type == "filter") {
                        this.allMovieNames = [...data.movieNamesData];
                      } 
                      else{
              this.refundRecords = [...data.Records];
              this.grandTotal = data.grandTotal;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
          }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
  </script>
  
  <style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }
  
  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  
  .swc-report-table td {
    white-space: nowrap;
  }
  
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  
  .swc_table_header th {
    border: 1px solid black !important;
  }
  
  .no_border {
    border: 0px !important;
  }
  
  .swap {
    color: #099bf9;
  }
  .reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/transactionsRefundReportOld.vue